import { Cable, DeviceThermostat, LocalLaundryService, OpenInBrowser, Science, SystemUpdateAlt } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Cargo } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

type CargoServicesProps = {
    cargo: Pick<Cargo, "isHoseRentalRequired" | "isInhibitedProduct" | "isNitrogenBlanketingRequired" | "isNitrogenPurgingRequired" | "isTemperatureControlRequired" | "isCleaningRequired">
	size?: "small" | "inherit" | "large" | "medium"
};
const CargoServiceIcons = ({ cargo, size = "small" }: CargoServicesProps) => {
	const color = "action";

	return <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
		{cargo.isHoseRentalRequired && (
			<Tooltip title={intl.formatMessage({ id: "HOSE_RENTAL" })}>
				<Cable fontSize={size} color={color} />
			</Tooltip>
		)}

		{cargo.isNitrogenPurgingRequired && (
			<Tooltip title={intl.formatMessage({ id: "NITROGEN_PURGING" })}>
				<SystemUpdateAlt fontSize={size} color={color} />
			</Tooltip>
		)}

		{cargo.isNitrogenBlanketingRequired && (
			<Tooltip title={intl.formatMessage({ id: "NITROGEN_BLANKETING" })}>
				<OpenInBrowser fontSize={size} color={color} />
			</Tooltip>
		)}

		{cargo.isInhibitedProduct && (
			<Tooltip title={intl.formatMessage({ id: "INHIBITED_PRODUCT" })}>
				<Science fontSize={size} color={color} />
			</Tooltip>
		)}

		{cargo.isTemperatureControlRequired && (
			<Tooltip title={intl.formatMessage({ id: "TEMPERATURE_CONTROL" })}>
				<DeviceThermostat fontSize={size} color={color} />
			</Tooltip>
		)}

		{cargo.isCleaningRequired && (
			<Tooltip title={intl.formatMessage({ id: "TANK_CLEANING" })}>
				<LocalLaundryService fontSize={size} color={color} />
			</Tooltip>
		)}
	</div>;
};

export default CargoServiceIcons;
